import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";

import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Solutions from "@/pages/Solutions";
import Apps from "@/pages/Apps";
import AISuite from "@/pages/AISuite";
import Pricing from "@/pages/Pricing";
import Industries from "@/pages/Industries";
import Integrations from "@/pages/Integrations";
import Security from "@/pages/Security";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import RequestDemo from "@/pages/RequestDemo";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import Terms from "@/pages/Terms";
// import DeleteAccount from "@/pages/Delete-Account";
import NotFound from "@/pages/NotFound";

function App() {
  return (
    <div className="App">
      <Toaster position="top-right" richColors closeButton />
      <BrowserRouter basename="/">
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<Home />} />
            <Route path="solutions" element={<Solutions />} />
            <Route path="apps" element={<Apps />} />
            <Route path="ai-suite" element={<AISuite />} />
            <Route path="pricing" element={<Pricing />} />
            <Route path="industries" element={<Industries />} />
            <Route path="integrations" element={<Integrations />} />
            <Route path="security" element={<Security />} />
            <Route path="about" element={<About />} />
            <Route path="privacy-policy" element={<PrivacyPolicy />} />
            <Route path="terms" element={<Terms />} />
            <Route path="contact" element={<Contact />} />
            {/* <Route path="delete-account" element={<DeleteAccount />} /> */}
            {/*
            <Route path="request-demo" element={<RequestDemo />} />
            */}
            <Route path="*" element={<NotFound />} /> 
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
